import React, { useState, useEffect, useRef } from 'react'
import CompanyRow from './company-row'
import BottomPagination from '../bottom-pagination'
import Filters from './filters'
import { ajaxGet } from '../../ajax'
import _ from 'lodash'

const ClientPortal = props => {
  const [showFilters, setShowFilters] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [filters, setFilters] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const timer = useRef()

  useEffect(() => { setIsLoading(false) }, [props.companies])

  const loadCompanies = (newFilters, newPage) => {
    var params = { page: newPage || props.page };

    (newFilters || filters).filter(f => f.completed).forEach((f, i) => {
      params[`filters[${i}][type]`] = f.type || 'and'
      params[`filters[${i}][query]`] = f.query
    })

    ajaxGet('/admins/companies.json?' + new URLSearchParams(params))
      .then(response => {
        const page = response.headers.get('X-Page')
        const totalCount = response.headers.get('X-Total')
        return response.json().then(json => ({ json, page, totalCount }))
      })
      .then(({ json, page, totalCount }) => {
        props.updateCompanies({
          companies: json.companies,
          page: page,
          totalCount: totalCount
        })
      })
  }

  const searchFilter = (value) => {
    return {type: 'and', column: 'name', condition: '~*', completed: true, value: value, query: `name ~* '${_.replace(_.escapeRegExp(value), /'/g, "''")}'`}
  }

  const applyFilters = (value) => {
    setIsLoading(true)
    setShowFilters(false)
    setFilters(value, null)

    searchValue.length ? loadCompanies([...value, searchFilter(searchValue)]) : loadCompanies(value)
  }

  const pageChange = (newPage) => { loadCompanies(null, newPage) }

  const handleSearch = (value) => {
    setIsLoading(true)
    setSearchValue(value)
    
    value.length ? loadCompanies([...filters, searchFilter(value)]) : loadCompanies(filters)
  }

  const onChangeSearch = value => {
    setSearchValue(value)

    clearTimeout(timer.current)
    timer.current = setTimeout(()=> handleSearch(value), 500)
  }

  return (
    <div className={'client-portal ' + (isLoading ? 'isLoading' : '')}>
      { isLoading && <div className='animated-spinner' /> }
      <div className='client-portal-header'>
        <div className='client-header-left'>
          <h1>Client Portal</h1>
          <div className='filters-wrapper'>
            <input className='form-control' placeholder='Search' value={searchValue} onChange={e => onChangeSearch(e.currentTarget.value)} />
            <button
              className={'btn btn-info filters' + (_.isEmpty(filters) ? ' inactive' : '')}
              onClick={() => setShowFilters(true)}>
                Filters
            </button>
          </div>
        </div>
        <div className='client-header-right'>
          <a onClick={() => window.location.href='/admins/companies/new'} className='new-client btn btn-success'>
            <div className='fa fa-plus' /> New Client
          </a>
        </div>
      </div>
      <div className='row'>
        <div className='col-lg-12'>
          <table className='table'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Locations</th>
                <th>Fields</th>
                <th>Regions</th>
                <th>Region</th>
              </tr>
            </thead>
            <tbody>
              {props.companies.map((company, index) => <CompanyRow key={index} company={company} />)}
            </tbody>
          </table>
        </div>
      </div>
      <BottomPagination
        onPageChange={pageChange}
        totalCount={props.totalCount}
        perPage={props.perPage}
        page={props.page} />
      { showFilters && 
        <Filters
          onClose={() => setShowFilters(false)}
          filters={filters}
          onApply={applyFilters}
        />
      }
    </div>
  )
}

export default ClientPortal
